import 'globalCommon/style/common.css';
import 'globalCommon/style/iconfont.css';
import 'globalCommon/style/reset.css';
import 'mCommon/style/common.css';

import { qrCode } from '@umu/page-side-qr-code';
import { gdprCom, ipPrompt } from '@umu/umu-prompt';
import 'babel-polyfill';
import { loadResource, registerBesChannels } from 'globalCommon/gdprResource';
import getUserInfo, { IUserInfo } from 'globalCommon/services/getUserInfo';
import isInitRegisterBtn from '../../../common/utils/isInitRegisterBtn';
import registerSentry from '../../../common/utils/sentry';
import { detectWebpSupport, detectAvifSupport } from '../../../common/utils/formatDetect';
import { applyForceFallback, watchPictureImgLoad, applyFormatActivation } from '../../../common/utils/pictureEnhance';
import { initHeader, initFooter } from 'globalCommon/utils/headerFooterRender';

if (document.body) {
    document.body.classList.add('locale-' + LOCALE.toLowerCase());
    document.body.classList.add('system-' + SYSTEM.toLowerCase());
}

detectWebpSupport();
detectAvifSupport();
declare global {
    interface Window {
        VERSION: string;
        Sentry: any;
        pageData: any;
        branch: string;
    }
}

const initGDPR = (userId?: string) => {
    gdprCom({
        userId,
        platform: 'm',
        lang: LOCALE.toLowerCase(),
        onAgree: () => {
            loadResource();
        },
    });
};

function showPrompt(userId?: string) {
    const commonConfig = {
        userId,
        stayFunc: initGDPR,
    };
    if (SYSTEM.toLowerCase() === 'en') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'CN',
                    from: 'UMU.COM',
                    to: 'umu.cn',
                    lang: 'cn',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'JP',
                    from: 'UMU.COM',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'global',
                    district_cn: '国际',
                    district_jp: 'グローバル',
                },
            ],
            commonConfig,
        );
    } else if (SYSTEM.toLowerCase() === 'em') {
        ipPrompt(
            [
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'CN',
                    from: 'UMU.IO',
                    to: 'umu.cn',
                    lang: 'en',
                    mainland_1: '中国',
                    mainland_2: 'mainland China',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
                {
                    ...commonConfig,
                    platform: 'm',
                    countryCode: 'JP',
                    from: 'UMU.IO',
                    to: 'umu.co',
                    lang: 'jp',
                    mainland_1: '日本',
                    mainland_2: 'Japan',
                    district_en: 'European',
                    district_cn: '欧洲',
                    district_jp: 'ヨーロッパ',
                },
            ],
            commonConfig,
        );
    } else {
        initGDPR(userId);
    }
}

export default (option?: { cb?: (userInfo: IUserInfo) => void; renderAfter?: () => void }) => {
    applyForceFallback();
    applyFormatActivation();
    document.addEventListener('DOMContentLoaded', watchPictureImgLoad, { once: true });

    const userInfo = getUserInfo();
    option?.renderAfter?.();

    if (userInfo?.umu_id === 0 && !userInfo?.user_name) {
        initHeader({ isMobile: true });
        isInitRegisterBtn();
    } else {
        initHeader({ isMobile: true, userInfo });
        isInitRegisterBtn(userInfo);
    }
    initFooter({ isMobile: true });
    qrCode({
        lang: LOCALE.toLowerCase(),
        system: SYSTEM.toLowerCase(),
    });
    option?.cb?.(userInfo);

    if (SYSTEM.toLowerCase() !== 'cn') {
        showPrompt(userInfo?.umu_id ? String(userInfo.umu_id) : undefined);
    } else {
        registerBesChannels();
    }

    option?.renderAfter?.();
    registerSentry();
};

window.VERSION = VERSION;
window.branch = BRANCH;
